import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { initDynatrace } from './lib/dynatrace/initDynatrace';

initDynatrace();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
